export default __webpack_public_path__ + "static/media/green-fibers.1354abe6.png";